// PARAQTA — жеңіл, құпиялылыққа қауіпсіз аналитика.
// Анонимді ID (localStorage) + fire-and-forget /api/track. Жеке дерек жоқ.
// Кіргеннен кейін backend anon_id → telegram_id жалғайды (көрді→тіркелді funnel).

function getAnonId() {
  try {
    let a = localStorage.getItem('pq_aid');
    if (!a) {
      a = 'a' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      localStorage.setItem('pq_aid', a);
    }
    return a;
  } catch (_) { return 'a0'; }
}

export function track(event, meta) {
  try {
    const body = JSON.stringify({
      anon_id: getAnonId(),
      event: String(event || ''),
      meta: meta ? (typeof meta === 'string' ? meta : JSON.stringify(meta)) : '',
    });
    fetch('/api/track', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch (_) {}
}

// Реф ұстау: `?ref=KOD` немесе `/b/KOD` → localStorage + backend-ке клик.
// URL тазаланады (қайта ұсталмас үшін). Реф табылса — кодты қайтарады.
export function captureRef() {
  try {
    const sp = new URLSearchParams(location.search);
    let code = sp.get('ref');
    if (!code) {
      // Кез келген код-сегментін ұстаймыз (латын емес — кириллица/кодталған да),
      // әйтпесе кодта бөгде таңба болса /b/ марафонға жібермей ҮНСІЗ сынады.
      const m = location.pathname.match(/^\/b\/([^/?#]{1,40})/);
      if (m) { try { code = decodeURIComponent(m[1]); } catch (_) { code = m[1]; } }
    }
    if (!code) return null;
    code = code.slice(0, 40);
    try { localStorage.setItem('pq_ref', code); } catch (_) {}
    // /b/КОД-пен келді → «X ұсынады» белгісі осы сессияда көрінеді (жалпы /marathon-да емес).
    try { sessionStorage.setItem('pq_ref_show', '1'); } catch (_) {}
    fetch('/api/ref/click', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code, anon_id: getAnonId() }),
      keepalive: true,
    }).catch(() => {});
    try { history.replaceState({}, '', '/'); } catch (_) {}
    return code;
  } catch (_) { return null; }
}
